import React from "react";
import "./PaymentLoadingModal.css";

const PaymentLoadingModal = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="payment-loading-overlay">
      <div className="payment-loading-modal">
        <div className="loading-spinner"></div>
        <h3>Confirming Your Payment</h3>
        <p>Please don't press back or close this window</p>
        <p className="processing-text">This may take a few moments...</p>
      </div>
    </div>
  );
};

export default PaymentLoadingModal; 